import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { getArticleBySlug } from '@/mocks/articleContent';

export default function AdvancedTechniques() {
  const a = getArticleBySlug('/guide/oopbuy-spreadsheet-advanced-techniques');
  if (!a) return null;
  return (<main><Navbar /><ArticleLayout title={a.title} subtitle={a.subtitle} readTime={a.readTime} image={a.image} imageAlt={a.imageAlt}>{a.content()}</ArticleLayout><Footer /></main>);
}